import React from 'react';
import Chip from './molecules/Chip';

/**
  # DayPartChip
 *
 * As part of the design system the  is a specific implementation
 * of the more generic Chip molecule, used to display the day part
 * availability of menu categories and items.
 */
const DayPartChip = ({ value }: { value: string }) => {
  return <Chip value={value} themeKey={'dayPartChip'} />;
};

export default DayPartChip;
